import React, { FC } from "react";
import CurrentUserPopup from "./components/CurrentUserPopup";
import { Menu, MenuButton, MenuList } from "@chakra-ui/react";
import icon from "assets/Icon_CWProfile.svg?url";

const CurrentUserIcon: FC = () => {
	return (
		<Menu>
			<MenuButton className="user-icon" aria-label="User Settings">
				<img className="CurrentUserIcon_image" src={icon} alt="" />
			</MenuButton>
			<MenuList>
				<CurrentUserPopup />
			</MenuList>
		</Menu>
	);
};

export default CurrentUserIcon;
